export type GoogleAddress = {
  address_components: Array<{
    short_name: string;
    types: string[];
  }>;
  geometry: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
};

export type DireccionForm = {
  direccion?: string;
  latitud?: string | number;
  longitud?: string | number;
};

export function parseGoogleAddress(direccion: GoogleAddress): string {
  const nro = direccion.address_components.find(c => c.types.includes('street_number'))!.short_name;
  const calle = direccion.address_components.find(c => c.types.includes('route'))!.short_name;
  const ciudad = direccion.address_components.find(c =>
    c.types.includes('administrative_area_level_3'),
  )!.short_name;

  return `${calle} ${nro}, ${ciudad}`;
}

export function asignarCoordenadas(direccion: GoogleAddress, formulario: DireccionForm): void {
  formulario.latitud = direccion.geometry.location.lat();
  formulario.longitud = direccion.geometry.location.lng();
}

export function asignarDireccion(direccion: GoogleAddress, formulario: DireccionForm): void {
  asignarCoordenadas(direccion, formulario);
  formulario.direccion = parseGoogleAddress(direccion);
}